const YesNoNode = require('../YesNoNode');
const UseAbility = require('../UseAbility');
const Q_injured_ally = require('./Q_injured_ally');
const BattleCalc = require('../../BattleCalc');

const TankDecision = function (actor, battleState, moveTowards) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.YES] = new Q_injured_ally(actor, battleState, moveTowards);

  // use defensive stance if DPS is not priority over Tank
  if (!Array.isArray(actor.ai.priorities) && typeof actor.ai.priorities === 'object') {
    actor.ai.priorities = Object.values(actor.ai.priorities);
  }
  node.stance_dancing = BattleCalc.getEquippedAbility(actor, 'stance_dancing');
  const tank_priority = actor.ai.priorities.findIndex((ele) => ele === 'tank');
  const dps_ranged_priority = actor.ai.priorities.findIndex((ele) => ele === 'dps_ranged');
  const dps_close_priority = actor.ai.priorities.findIndex((ele) => ele === 'dps_close');
  const dps_priority_above_tank =
    dps_ranged_priority < tank_priority || dps_close_priority < tank_priority;
  node.branches[node.NO] =
    node.stance_dancing && !dps_priority_above_tank
      ? new UseAbility({
          actor,
          abilityHandle: 'stance_dancing',
          staticTarget: actor,
          stance: 'defensive_stance',
          altNode: node.branches[node.YES],
        })
      : node.branches[node.YES];

  // if i'm a ranged_dps unit, skip this tree
  const actor_is_pure_ranged = BattleCalc.unitIsPureRanged(actor);

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.stance_dancing = null;
    originalDispose.call(node);
  };

  node.query = function () {
    if (actor_is_pure_ranged) return null;

    // am i in a defensive stance?
    if (BattleCalc.getCondition(this.actor, 'defensive_stance')) {
      return this.branches[this.YES].query();
    } else {
      return this.branches[this.NO].query();
    }
  };

  return node;
};
module.exports = TankDecision;
